import React from 'react'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import InventoryMovementsList from '@shared/inventory_movements/List'

import { inventoryMovementService } from '@services/admin/inventoryMovementService'

export default function AdminInventoryMovementsList() {
  const { addJob } = useAdminNotification()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.inventory_movements']}
      />
      <InventoryMovementsList
        service={inventoryMovementService}
        role="admin"
        addJob={addJob}
      />
    </div>
  )
}
